export default __webpack_public_path__ + "static/media/alcohol-yellow.e1bc98b0.svg";